import request from '@jin10/utils/lib/request'

const axios = request.create({
  withCredentials: true,
  baseURL: process.env.NODE_ENV === '0development' ? '' : 'https://icbc-activity.jin10.com',
})

const userBase = process.env.NODE_ENV === '0development' ? '' : 'https://uc-api.jin10.com'
const referenceBase = process.env.NODE_ENV === '0development' ? '' : 'https://reference-api.jin10.com'

axios.defaults.headers.common['x-app-id'] = 'IQxvFSeUoQMgAIMo'
axios.defaults.headers.common['x-version'] = '1.0.0'

// 报名
export const signUp = (data = {}) => axios.post('/icbc-trade-contest-apply/applyV2', data)

// 查看报名信息
export const queryApplyInfo = (params = {}) => axios.get('/icbc-trade-contest-apply/whetherToSignUp', { params })

// 获取自己的总排名
export const getTotalRankingByUser = (params = {}) => axios.get('/trade-contest-leader-board-total/findByUserId', { params })

// 获取自己的周排名
export const getWeekRankingByUser = (params = {}) => axios.get('/trade-contest-leader-board-week/findByUserId', { params })

// 周排行榜
export const getWeekRanking = (params = {}) => axios.get('/trade-contest-leader-board-week/page', { params })

export const getTopWeekRanking = (params = {}) => axios.get('/trade-contest-leader-board-week/getTop10', { params })

// 总排行榜
export const getTotalRanking = (params = {}) => axios.get('/trade-contest-leader-board-total/page', { params })

export const getTopTotalRanking = (params = {}) => axios.get('/trade-contest-leader-board-total/getTop10', { params })

// 统计信息
export const getStatData = (params = {}) => axios.get('/trade-contest-data/query', { params })

// 根据id获取用户信息
export const getUsersByIds = (params = {}) => axios.get(userBase + '/out/getUserinfo', { params })

// 根据分类id和类型获取列表
export const getReference = (params = {}) =>
  axios.get(referenceBase + '/reference/getByCid', {
    params: params,
    headers: {
      'x-version': '1.0.1',
    },
  })

export const getReferenceById = (params = {}) =>
  axios.get(referenceBase + '/reference/getOne', {
    params: params,
    headers: {
      'x-version': '1.0.1',
    },
  })

export const getNow = () => axios.get('/trade-contest-data/getNow')
